<template>
  <b-link to="/" class="c-logo">
    <p class="c-logo__signet">
      <mtg-logo></mtg-logo>
      <strong class="u-invisible">MTG</strong>
    </p>
    <p class="c-logo__claim">
      <strong><br />{{ $t("lang.label_pqc_ca") }}</strong>
    </p>
  </b-link>
</template>
<script>
import MtgLogo from "./MtgLogo";

export default {
  name: "MtgHeaderLink",
  components: {
    MtgLogo
  }
};
</script>
